module.exports = __webpack_public_path__ + "img/fanke-propa.186a42d4.png";